import React from 'react'

export const GraphProfile = ({ data }: { data: any }) => {
  return (
    <div className="mt-10 relative px-3">
      <div className="absolute top-[39%] text-[#101A36B2] left-1/2 -translate-x-1/2 z-10 font-semibold text-center">
        {data.subtitle}
        <p
          className="text-[88px] font-percent leading-[98px] tracking-[-1px] font-medium bg-clip-text text-transparent"
          style={{ backgroundImage: 'linear-gradient(180deg, #FF821B 0%, #E46700 100%)' }}
        >
          {data.percents}
        </p>
      </div>
      <img className="w-full" src={data.graph} alt={data.subtitle} width={200} height={200} />
      <p className="absolute bottom-0 left-[6%] text-[14px] font-semibold opacity-70">0</p>
      <p className="absolute bottom-0 right-[4%] text-[14px] font-semibold opacity-70">100</p>
    </div>
  )
}
